import type { User } from '../types/auth.types';

/**
 * Fixture session for `mockBaseQuery` mode (`VITE_USE_MOCK_API=true`).
 *
 * The mock adapter never sets or reads the real HttpOnly session cookie —
 * that mechanism is backend-owned and out of scope for a client-side mock.
 * Standing in for "already signed in" here is sufficient: it exercises the
 * exact same `getSession`/`login`/`logout` call sites and Redux state the
 * real cookie-backed flow will drive once the backend exists.
 */
export const mockUserFixture: User = {
  id: 'user-1',
  email: 'demo@fastautomate.com',
  name: 'Demo Agency Admin',
  role: 'admin',
};
